import { alpha, useTheme } from '@mui/material/styles'
import { useMemo } from 'react'
import { useChat } from '../context/useChat'

const getInitials = (name: string) =>
  name
    .split(' ')
    .map(chunk => chunk.charAt(0))
    .join('')
    .toUpperCase()

export const ChatHeader = () => {
  const theme = useTheme()
  const {
    conversation,
    participantDisplayName,
    participantAvatarUrl,
    typingParticipant,
  } = useChat()

  const fallbackAvatarStyle = useMemo(
    () => ({
      background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
      color: theme.palette.primary.contrastText,
    }),
    [
      theme.palette.primary.contrastText,
      theme.palette.primary.dark,
      theme.palette.primary.main,
    ]
  )

  const title =
    participantDisplayName ??
    conversation?.friendlyName ??
    conversation?.uniqueName ??
    'Secure Chat'

  const statusText = typingParticipant ? 'Typing…' : null

  return (
    <div className="flex items-center gap-4 border-b border-slate-100 px-6 py-4">
      {participantAvatarUrl ? (
        <img
          src={participantAvatarUrl}
          alt={title}
          className="h-11 w-11 rounded-full object-cover shadow-sm"
        />
      ) : (
        <div
          className="flex h-11 w-11 items-center justify-center rounded-full text-sm font-semibold shadow-sm"
          style={fallbackAvatarStyle}
        >
          {getInitials(title)}
        </div>
      )}

      <div className="min-w-0 flex-1">
        <p className="truncate text-[15px] font-semibold text-slate-800">
          {title}
        </p>
        {statusText && (
          <p className="mt-0.5 text-xs font-medium text-emerald-600 transition-colors">
            {statusText}
          </p>
        )}
      </div>
    </div>
  )
}
